import React, { useContext, useState } from 'react'
import withAuth from '../utils/withAuth'
import { useNavigate } from 'react-router-dom'
import "../App.css";
import { Button, IconButton, TextField } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import VideocamIcon from '@mui/icons-material/Videocam';
import SecurityIcon from '@mui/icons-material/Security';
import HighQualityIcon from '@mui/icons-material/HighQuality';
import GroupIcon from '@mui/icons-material/Group';
import { AuthContext } from '../contexts/AuthContext';

function HomeComponent() {


    let navigate = useNavigate();
    const [meetingCode, setMeetingCode] = useState("");


    const {addToUserHistory} = useContext(AuthContext);
    let handleJoinVideoCall = async () => {
        await addToUserHistory(meetingCode)
        navigate(`/${meetingCode}`)
    }

    return (
        <>
            <nav className="home-navbar">
                <div className="home-navbar-container">
                    <div className="home-navbar-logo">
                        <VideocamIcon style={{ fontSize: '2rem', color: '#6B8E23' }} />
                        <span>Nxtmeet</span>
                    </div>
                    <div className="home-navbar-actions">
                        <button className="home-nav-history" onClick={() => navigate("/history")}>
                            <RestoreIcon />
                            <span>History</span>
                        </button>
                        <Button 
                            className="home-nav-logout"
                            onClick={() => {
                                localStorage.removeItem("token")
                                navigate("/auth")
                            }}
                        >
                            Logout
                        </Button>
                    </div>
                </div>
            </nav>

            <section className="home-hero-section">
                <div className="home-hero-container">
                    <div className="home-hero-content">
                        <div className="home-trust-badge">
                            <SecurityIcon style={{ fontSize: '1.2rem' }} />
                            <span>Secure & Encrypted Meetings</span>
                        </div>
                        
                        <h1 className="home-hero-title">Providing Quality Video Call Just Like Quality Education</h1>
                        
                        <p className="home-hero-subtitle">
                            Join or create high-quality video meetings instantly. Connect with anyone, anywhere with crystal-clear audio and video.
                        </p>

                        <div className="home-meeting-form">
                            <TextField 
                                onChange={e => setMeetingCode(e.target.value)} 
                                id="outlined-basic" 
                                label="Enter Meeting Code" 
                                variant="outlined"
                                fullWidth
                                className="home-meeting-input"
                            />
                            <Button 
                                onClick={handleJoinVideoCall} 
                                variant='contained'
                                className="home-join-btn"
                            >
                                Join Meeting
                            </Button>
                        </div>

                        <div className="home-features-quick">
                            <div className="home-quick-feature">
                                <SecurityIcon style={{ color: '#6B8E23' }} />
                                <span>End-to-End Encrypted</span>
                            </div>
                            <div className="home-quick-feature">
                                <HighQualityIcon style={{ color: '#6B8E23' }} />
                                <span>HD Quality</span>
                            </div>
                            <div className="home-quick-feature">
                                <GroupIcon style={{ color: '#6B8E23' }} />
                                <span>Unlimited Participants</span>
                            </div>
                        </div>
                    </div>

                    <div className="home-hero-image">
                        <div className="home-image-placeholder">
                            <div className="home-video-mockup">
                                <div className="home-mockup-header">
                                    <div className="home-mockup-dot"></div>
                                    <div className="home-mockup-dot"></div>
                                    <div className="home-mockup-dot"></div>
                                </div>
                                <div className="home-mockup-content">
                                    <VideocamIcon className="home-mockup-icon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export default withAuth(HomeComponent)